import { Palette } from "@mui/material";

const palette = {
  primary: {
    main: "#1749D1",
    hover: "#053BB3",
  },
  third: {
    main: "#eef2ff",
    contrastText: "#2952e3",
  },
  deepGray: {
    main: "rgba(255,255,255,.1)",
    hover: "rgba(255, 255, 255, .18)",
  },
  background: {
    default: "#E4EBFF",
  },
  bgSwitch: "#F6F8FF",
  bgCase: "#F5F8FF",
  secondary: {
    main: "#FFC43B",
  },
  white: "#fff",
  logo: "#FF5C00",
  blue: {
    100: "#7499FF",
    200: "#1E293B",
    300: "#1e3a8a",
  },
  divider: "#CCDAFF",
  text: {
    primary: "#212121",
    secondary: "#666666",
    disabled: "#9E9E9E",
  },
  base: {
    700: "#212121",
    500: "#666666",
    300: "#9E9E9E",
    200: "#A9A9A9",
    100: "#E0E0E0",
    70: "#e0e0e09d",
    50: "#F5F5F5",
  },
  error: {
    main: "#E53B35",
    contrastText: "#F6514C",
  },
  red: {
    contrast: "#E53B35",
    light: "#FDD5D4",
  },
  orange: {
    contrast: "#FF7405",
    light: "#FFE6AC",
  },
  orangeNew: {
    main: "rgba(217,119,6,.25)",
    light: "#FCD34D",
    hover: "rgba(217,119,6,.4)",
  },
  orangeSecondary: {
    main: "#FFFBEB",
    contrastText: "#92400E",
  },
  green: {
    contrast: "#008836",
    light: "#D2F0DF",
  },
  greenNew: {
    main: "rgba(5,150,105,.3)",
    light: "#6EE7B7",
    hover: "rgba(5,150,105,.45)",
  },
  status: {
    created: "#7499FF",
    received: "#1749D1",
    started: "#44BF78",
    completed: "#A9A9A9",
    canceled: "#212121",
  },
  border: "#E0E0E0",
  testing: {
    personal: "#94D4FF",
    private: "#D4AAE5",
    open: "#C5EBA4",
    public: "#FFE6AC",
  },
  grade: {
    0: "#3B82F6",
    1: "#22C55E",
    2: "#EAB308",
    3: "#8B5CF6",
    4: "#fc869a",
    5: "#043b94",
    6: "#008475",
    7: "#735600",
    8: "#4e1fbe",
    9: "#EF4444",
  },
} as Palette;

export const TEAM_MEMBER_AVATAR_COLORS = [
  palette.primary.main,
  palette.secondary.main,
  palette.logo,
  palette.blue[100],
  palette.green.contrast,
  palette.orange.contrast,
  palette.red.contrast,
  palette.grade[3],
  palette.grade[6],
  palette.grade[9],
];

export default palette;
